<script setup>
import { ref, computed, watch, defineAsyncComponent } from 'vue'
import { useGlobalStore } from '@stores/global.js'
import { useRoute } from 'vue-router'
import Loading from '@components/global/Loading.vue'
import Arrow from '@components/global/accents/Arrow.vue'
import Stamp from '@components/global/accents/Stamp.vue'
import Button from '@components/global/forms/Button.vue'
import Contact from '@sections/global/Contact.vue'
// const canGoBack = computed(() => window.history.length > 2)

const global = useGlobalStore()
const socials = ref([
	{
		title: 'Behance',
		icon: 'fab fa-behance',
		href: 'https://behance.com/papercrowns',
	},
	{
		title: 'X (Twitter)',
		icon: 'fab fa-x-twitter',
		href: 'https://www.x.com/papercrowns',
	},
	{
		title: 'Instagram',
		icon: 'fab fa-instagram',
		href: 'https://www.instagram.com/papercrowns',
	},
	{
		title: 'LinkedIn',
		icon: 'fab fa-linkedin',
		href: 'https://www.linkedin.com/company/papercrowns',
	},
])

// import markdownit from 'markdown-it'

const route = useRoute()
const loading = ref(false)
const project = ref({})
const requestProject = ref(null)
const slug = computed(() => route.params.slug)

const sections = ref({
	hero_image: 'HeroImage',
	details: 'Details',
	image: 'Image',
	vimeo: 'Vimeo',
})
// const md = markdownit()

// const body = computed(() => {
// 	return article.value.body ? md.render(article.value.body) : null
// })

const loadSection = (name) => {
	let section = sections.value[name]
	return section ? defineAsyncComponent(() => import(`@sections/project/${section}.vue`)) : null
}

function cancelProject() {
	if (requestProject.value) requestProject.value.cancel()
}
function getProject() {
	loading.value = true
	project.value = {}
	cancelProject()
	let axiosSource = axios.CancelToken.source()
	requestProject.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/project/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			project.value = a.data
		})
		.catch((e) => {})
}
getProject()

watch(slug, async () => {
	getProject()
})
</script>

<template>
	<Loading v-if="loading" />
	<main class="flex flex-col gap-10 bg-crowns-off-black bg-[url('https://cdn.papercrowns.com/website/images/backgrounds/article-texture.png')] bg-[length:auto_600px] bg-no-repeat pt-32" v-else>
		<section class="container pb-5">
			<div class="relative flex justify-center">
				<div class="lg:w-9/12">
					<!-- Back Arrow -->
					<div class="absolute left-0 top-3 hidden w-48 lg:block">
						<Arrow rotate="45" arrow_rotate="-45" shift="backward" :to="{ name: 'work' }" />
					</div>

					<!-- Project Intro -->
					<div class="col-span-4 flex w-full flex-col gap-5">
						<span class="label">Project</span>
						<h2>{{ project.name }}</h2>
						<div class="flex flex-col gap-5 md:flex-row">
							<div class="flex gap-4">
								<div class="flex items-center gap-2">
									<Stamp :size="global.screenWidth > 1024 ? 'md' : 'sm'" />
									<Stamp :size="global.screenWidth > 1024 ? 'md' : 'sm'" :accent="project.client.accent_color">{{ project.client.stamp }}</Stamp>
								</div>
								<div class="flex flex-col justify-center gap-1">
									<div class="font-neue-haas-grotesk font-semibold leading-none">Paper Crowns</div>
									<div class="font-neue-haas-grotesk font-semibold leading-none" :style="{ color: project.client.accent_color }">{{ project.client.name }}</div>
								</div>
							</div>
							<Button class="hidden md:block" type="underline" label="See Full Project on Behance" v-if="project.behance_url" :href="project.behance_url" />
						</div>
						<p v-if="project.description" v-html="project.description"></p>
						<Button class="md:hidden" type="underline" label="See Full Project on Behance" v-if="project.behance_url" :href="project.behance_url" />
					</div>
				</div>
			</div>
		</section>

		<template v-for="block in project.content?.content">
			<component v-if="block.type == 'customBlock'" :is="loadSection(block.attrs?.id)" :project="project" :config="block.attrs?.config" />
		</template>

		<section class="py-12">
			<div class="container">
				<div class="flex justify-center">
					<div class="2xl:w-9/12">
						<div class="flex flex-col items-center gap-10">
							<Button class="hidden xl:block" mega="swords" v-if="project.behance_url" :href="project.behance_url">See Full Project on Behance</Button>
							<Button class="block xl:hidden" mega="swords" v-if="project.behance_url" :href="project.behance_url">See Project on Behance</Button>

							<div class="flex gap-1.5">
								<Button variant="social dark" v-for="social in socials" :icon="social.icon" :href="social.href" @click="global.closeModal()" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<Contact />
	</main>
</template>
